export default __webpack_public_path__ + "static/media/discord.c8e6c630.png";